import { useLazyQuery } from "@apollo/client";
import Image from "next/image";
import { useEffect, useState, memo } from "react";
import { toast } from "react-toastify";

import { useGetSet } from "@api/hooks/queries/useGetSet";
import { GET_SET } from "@api/queriesV2/cms";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { blurDataURL } from "@config/config";
import { useMediaQuery } from "@hooks/useMediaQuery";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";

import { typeSlider } from "./datas";
import s from "./GaleryV3Block.module.scss";

const GaleryV3Block = ({ settings, data, updateField }) => {
  const { isMobile } = useMediaQuery();
  const { title, collections } = data;
  const { sliderV3 } = collections;
  const { items } = sliderV3;
  const { blockType } = settings.common;

  const [allSlides, setAllSlides] = useState([]);

  const [getSet] = useGetSet({ lazy: true });

  useEffect(() => {
    const promises = [];
    const filtered = items.filter((item) => {
      return typeof item.isShow === "boolean" ? item.isShow : true;
    });
    filtered.forEach((item) => {
      if (item.setId) {
        promises.push(
          getSet({
            variables: {
              id: item.setId,
            },
          }),
        );
      }
    });

    Promise.all(promises).then((data) => {
      setAllSlides([]);
      let counter = 0;
      filtered.forEach((item) => {
        if (item.setId) {
          const setPages = data[counter].data.getSet.data.map((page) => {
            return {
              title: page.title,
              alt: page.seo.description,
              image: page.seo.thumbnailBig || page.seo.thumbnail,
              description: page.seo.description,
              // link: `/${getPageFolderName()[slide.setType]}/${page.slug}`,
            };
          });

          setAllSlides((slides) => [...slides, ...setPages]);

          counter += 1;

          return;
        }

        setAllSlides((items) => [...items, item]);
      });
    });
  }, [items]);

  return (
    <Container className={s.galeryV3}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            collectionType={typeSlider}
            // autoScroll
            slidesCount={allSlides.length}
            startPadding={isMobile}
            className={s.slider}
            render={(sliderProps) => {
              return (
                <>
                  <div className={s.descriptions}>
                    <div className={s.description}>
                      <div className={s.subTitle}>
                        {allSlides[sliderProps.currentSlide]?.title}
                      </div>
                      <div className={s.text}>
                        {allSlides[sliderProps.currentSlide]?.description}
                      </div>
                    </div>
                    {!isMobile && (
                      <SliderControls className={s.controls} {...sliderProps} />
                    )}
                  </div>
                  <SliderSlides {...sliderProps} className={s.slides}>
                    {allSlides.map((slide, key) => (
                      <div key={key} className={s.slide}>
                        <Image
                          src={slide.image}
                          fill
                          style={{
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          alt={slide.alt}
                          // quality={100}
                          // sizes="(max-width: 767px) 259px, 417px"
                          blurDataURL={blurDataURL}
                        />
                      </div>
                    ))}
                  </SliderSlides>
                  {isMobile && (
                    <SliderControls className={s.controls} {...sliderProps} />
                  )}
                </>
              );
            }}
          />
        </section>
      </Container>
    </Container>
  );
};

export default memo(GaleryV3Block);
